import { useCallback, useMemo } from 'react';

function useScrollBehavior() {
    const prefersReducedMotion = useMemo(() => window.matchMedia('(prefers-reduced-motion: reduce)').matches, []);
    const scrollBehavior: ScrollBehavior = prefersReducedMotion ? 'auto' : 'smooth';

    const scrollToElement = useCallback(
        (id: string): boolean => {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: scrollBehavior });
                return true;
            }
            return false;
        },
        [scrollBehavior]
    );

    const scrollToTop = useCallback((behavior: ScrollBehavior = scrollBehavior) => {
        window.scrollTo({ top: 0, behavior: behavior });
    }, [scrollBehavior]);

    return { scrollToElement, scrollToTop };
}

export default useScrollBehavior;
